import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";

const sortStudentGrades = (rows) => {
  if (!rows?.length) return rows

  const bySubject = {}
  rows.forEach((r) => {
    if (!bySubject[r.subjectId]) bySubject[r.subjectId] = []
    bySubject[r.subjectId].push(r)
  })

  const sortGroup = (group) => {
    const course = group.filter((r) => r.level === -1).sort((a, b) => a.order - b.order)
    const items = group.filter((r) => r.level > -1)
    if (!items.length) return course

    let order = []
    const maxLevel = Math.max(...items.map((r) => r.level))
    for (let i = 0; i <= maxLevel; i++) {
      order = order.concat(
        items.filter((r) => r.level === i).sort((a, b) => a.order - b.order)
      )
    }

    const courseIds = new Set(course.map((r) => r.conceptId))
    const itemIds = new Set(items.map((r) => r.conceptId))
    let res = order.filter(
      (r) => r.parentId == null || courseIds.has(r.parentId) || !itemIds.has(r.parentId)
    )

    if (res.length > 0) {
      let index = 0
      const insertChildren = () => {
        if (res.length === order.length) return
        order.forEach((e) => {
          if (e.parentId === res[index].conceptId) {
            res.splice(
              index + res.filter((x) => x.parentId === res[index].conceptId).length + 1,
              0,
              e
            )
          }
        })
        index++
        insertChildren()
      }
      insertChildren()
    } else {
      res = order
    }

    return [...course, ...res]
  }

  return Object.keys(bySubject)
    .sort((a, b) => Number(a) - Number(b))
    .flatMap((sid) => sortGroup(bySubject[sid]))
}

export default (context) => {
  return {

    config: {
      pageSize: 40,
      customPathGet: "admGrades/reports",
      list: false,
      enableContexMenu: true,
      remap: (r, row) => {
        r.data.Results = r.data.Results.map(row)
        return r;
      },
      remapRow: (row) => {
        if(row.grades>0)row.grades+=' notas';
        else if(row.grades===0) row.grades='No';
        else row.grades='Sí';
        return row;
      }
    },

    actions: {
      create: false,
      edit: false,
      delete: false,
      print: false,
      export: false,
      search: true
    },

    extras:{
      items: [
        {id: 0, icon: 'simple-icon-cloud-download', name: 'Generar libretas', onClick: () => {
          const content = {
            name: "Generar libretas",
            fields: [
              {
                col: 6,
                name: "superSectionId",
                value: null,
                type: "select",
                label: "Grado",
                rules: "required",
                opts: {
                  style: 'float-label',
                  path: "/admSuperSection/get?pick=true"
                }
              },
              {
                name: "periodId",
                value: context.state.formFilter.periodId,
                type: "hidden",
              },
            ],
            buttons: [
              {
                label: "Descargar",
                onClick: (ctx) => {
                  ctx.validateForm().then(() => {
                    context.props.setLoader(true)
                    _axios
                      .get(`admGrades/job/archive/zip?supersectionId=${ctx.state.superSectionId}&periodId=${ctx.state.periodId}`)
                      .then(r => {
                        if (r.status === 0) {
                          if (r.data && r.data.url) window.open(r.data.url)
                          context.toggleRight()
                        }
                        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                        context.props.setLoader(false)
                      }).catch(e => {
                        context.props.setLoader(false)
                      })
                  })
                  .catch(e => { /* console.log(e) */ })
                }
              }
            ]
          }

          context.setState({modalRightContent: content}, () => {
            context.toggleRight() 
          })
        }}
      ],
      itemsInRowsTable: [
        {
          icon: 'simple-icon-note',
          name: 'Ver notas de alumno',
          onClick: (row, ctx) => {
            ctx.view.extras.itemsInRowsTable[0].form.name = 'Notas para: ' + row.name
          },
          form: {
            name: 'Notas de alumno',
            remapGET: () => {
               return { studentId: context.state.idItemPreSelected }
            },
            detailGrid: () => {
              return {
                module: 'admGradesDetail',
                parentIdField: 'studentId',
                embeded: (c) => {
                  return {
                    config: {
                      hiddenTitle: true,
                      pageSize: 1000,
                      list: false,
                      customPathGet: 'admGrades/getByStudent/' + context.state.idItemPreSelected,
                      remap: (list, remapRow) => {
                        list.data.Results = sortStudentGrades(list.data.Results || []).map(remapRow)
                        return list
                      },
                      remapRow: (r) => {
                        r.grade = r.gradeNum === null ? r.gradeTxt : r.gradeNum
                        if (r.l) { r.l0 = '-'; r.l1 = '-' }
                        else if (r.l0) { r.l1 = '-' }
                        return r
                      }
                    },
                  
                    actions: {
                      print:true,
                      export: {local: true}
                    },
              
                    filter: {
                      fields: [
                        {
                          col: 4,
                          name: "periodId",
                          value: { value: "0", label: "Actual" },
                          type: "select",
                          label: "Periodo",
                          opts: {
                            style: 'float-label',
                            path: "admPeriod/get?pick=true",
                            isClearable: false
                          },
                          onChange: (ctx) => {
                            const basePeriodId = context.state.formFilter.periodId && (context.state.formFilter.periodId.value || context.state.formFilter.periodId)
                            const selectedPeriodId = ctx.state.periodId && (ctx.state.periodId.value || ctx.state.periodId)
                            if (!selectedPeriodId || String(basePeriodId) === String(selectedPeriodId)) return
                            process.nextTick(() => { c.resetDataTable() })
                          }
                        },
                        {
                          name: "levelCount",
                          value: 1,
                          hidden: true
                        }
                      ]
                    },
  
                    columns: [
                      { Header: "Curso", accessor: "l" },
                      { Header: "Concepto 1", accessor: "l0" },
                      { Header: "Concepto 2", accessor: "l1" },
                      { Header: "Nota", accessor: "grade" }
                    ]
                  }
                }
              }
            },
            okMsg: 'Ok',
            fields: [
              { name: "studentId", value: 0, type: "hidden" },
              { name: "levelCount", value: 1, type: "hidden" }
            ],
            onSuccess: (r) => { },
            onError: (e) => { }
          }
        },
        {
          id: 1, icon: 'simple-icon-cloud-download', name: 'Descargar reporte',
          onClick: (row, ctx) => {
             var path = ctx.state.formFilter.reportType === 'lib' ? 
             ('grades/pdfreport/' + ctx.state.formFilter.year + '/' + row.ID + '?periodId=' + ctx.state.formFilter.periodId) :
             ('grades/memo/' + ctx.state.formFilter.periodId + '/' + row.ID) 
            context.props.setLoader(true)
            _axios
              .get(path)
              .then(r => {
                if (r.status >= 0) {
                  window.URL = window.URL || window.webkitURL;
                  var xhr = new XMLHttpRequest(), a = document.createElement('a'), file;
                  xhr.open('GET', r.data.url, true);
                  xhr.responseType = 'blob';
                  xhr.onload = function () {
                      file = new Blob([xhr.response], { type : 'application/octet-stream' });
                      a.href = window.URL.createObjectURL(file);
                      a.download = r.data.filename;  
                      a.click();
                  };
                  xhr.send();
                }
                NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                context.props.setLoader(false)
              }).catch(e => {
                context.props.setLoader(false)
              })
          }
        }
      ]
    },

    filter: {
      fields: [
        {
          name: "reportType",
          value: "lib",
          type: "select",
          label: "Tipo de reporte",
          opts: {
            style: 'float-label',
            items: [
              {
                value: "lib",
                label: "Libretas de notas"
              },
              {
                value: "mem",
                label: "Memorandos"
              }
            ],
            isClearable: false
          }
        },
        {
          name: "year",
          value: new Date().getFullYear(),
          type: "select",
          label: "Año",
          opts: {
            style: 'float-label',
            items: function(){
              var years=[];
              for (let i = new Date().getFullYear(); i > new Date().getFullYear()-5; i--) years.push(i);
              return years.map((m)=> {return {
                value: m,
                label: m
              }});
            }(),
            isClearable: false
          }
        },
        {
          name: "periodId",
          value: { value: "0", label: "Actual" },
          type: "select",
          label: "Periodo",
          parent: "year",
          opts: {
            style: 'float-label',
            path: () => { return "/admPeriod/get?pick=true&year="+context.state.formFilter.year },
            isClearable: false
          }
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "Grado",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
            name: "sectionId",
            value: "",
            type: "select",
            label: "Sección",
            parent: "superSectionId",
            opts: {
              style: 'float-label',
              path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFilter.superSectionId }
            },
            renderIf: (ctx) => { return  ctx.state.superSectionId }
        },
      ],
      buttons: [
        {
          label: 'Ver reportes',
          renderIf: (ctx) => { return ctx.state.periodId || ctx.state.superSectionId },
          onClick: (ctx) => {
            context.view.config.customPathGet = ctx.state.reportType === 'lib' ? 'admGrades/reports' : 'admGrades/notpassed';
            ctx.btnAction('filter') 
          }
        }
      ]
    },

    form: {
      fields: []
    },

    columns: [
      {
        Header: "Código",
        accessor: "externalId"
      },
      {
        Header: "Alumno",
        accessor: "name"
      },
      {
        Header: "Grado / sección",
        accessor: "sectionTag"
      },
      {
        Header: "Notas ingresadas",
        accessor: "grades"
      }
    ]
  }
}